import './style.less';
import * as React from 'react';
import { Button } from 'telstra-ui/components/button/Button';
import { loading } from '@redux/actions/loading';
import { connect } from 'react-redux';
import { Spinner } from 'telstra-ui/components/spinner/spinner';

import { errorCloudStumbled } from '@images';
interface IPageLoadingIndicatorDispatchProps {
    showGlobalSpinner: () => void;
    hideGlobalSpinner: () => void;
}

interface IPageLoadingIndicatorProps extends IPageLoadingIndicatorDispatchProps {
    error: boolean;
}

class PageLoadingIndicatorComponent extends React.Component<IPageLoadingIndicatorProps> {
    constructor(props) {
        super(props);
    }

    public render() {
        const { error } = this.props;
        /* istanbul ignore else */
        return error ? this.renderPageLoadError() : this.renderPageLoader();
    }

    private readonly renderPageLoader = () => {
        return this.renderPageCenter(
            <div>
                <Spinner size="tl-spinner-large" />
            </div>
        );
    }
    private readonly renderPageLoadError = () => {
        this.props.hideGlobalSpinner();
        return this.renderPageCenter(
            <div>
                <div className="tc-billing-page-load-indicator">
                    <img src={errorCloudStumbled} />
                </div>
                <span className="tc-billing-page-load-failed-text">
                    Failed to load the requested resource
                </span>
                <div className="tc-billing-try-again">
                    <Button onClick={this.tryAgain}>Try again</Button>
                </div>
            </div>
        );
    }

    private readonly renderPageCenter = (component) => {
        return (
            <div className="tc-billing">
                <div id="tc-billing-page-load-center">
                    <div className="tc-billing-page-load-indicator-container">
                        {component}
                    </div>
                </div>
            </div>
        );
    }

    private readonly tryAgain = () => {
        return window.location.reload();
    }
}

const mapDispatchToProps = (dispatch): IPageLoadingIndicatorDispatchProps => {
    return {
        showGlobalSpinner: () => dispatch(loading(true)),
        hideGlobalSpinner: () => dispatch(loading(false)),
    };
};

export const PageLoadingIndicator =
    connect<null, IPageLoadingIndicatorDispatchProps>
    (null, mapDispatchToProps)(PageLoadingIndicatorComponent);
